import { UserViewModel, EvalDetailsV } from '../global/model';
import { CompartType } from '../compart/model';
import { EquipmentViewModel } from '../search/model';
export class equipmentVwMdl {
    public Id: number;
    public customerId: number;
    public customerName: string;
    public jobsiteId: number;
    public jobsiteName: string;
    public make: string;
    public makeId: number;
    public model: string;
    public modelId: number;
    public family: string;
    public familyId: number;
    public serial: string;
    public unit: string;
    public smu: number;
    public ltd: number;
    public lastInspectionId: number;
    public lastInspectionDate: string;
    public lastInspectionDateAsDate: Date;
    public quoteId: number;
    public EvalL: string;
    public EvalR: string;
    public overAllEvalNumber: number;
    public Status: string;
    public NextInspectionDate: Date;
    public NextInspectionSMU: number;
    public RopeShoveEvalL : string;
    public RopeShoveEvalR:string;
    public inspector:string;
    public therm_L:string;
    public therm_R:string;
    public addiunit:string;
    public pmu: number;
    public pmupercentage:number;

    public WornL:number;
    public WornR:number;
    public RopeShovelWornL:number;
    public RopeShovelWornR:number;
    public residual:number;
    public replacementDate:Date;
    public replacementDateAsString: string;
    public AvgUsage:number;
    public Distance:number;
    public SummaryNotesExists: boolean;
}

export class ComponentOverViewVwMdl {
    public Id: number;
    public CompartId: number;
    public CompartPart: string;
    public CompartStr: string;
    public CompartTypeId: number;
    public CompartTypeStr: string;
    public SystemId: number;
    public EquipmentId: number;
    public SystemSerial: string;
    public Side: number;
    public WornPercentage: number;
    public EvalCode: string;
    public CMU: number;
    public RemainingLife100: number;
    public RemainingLife120: number;
    public ComponentInstallationDate: Date;
    public ComponentInstallationDateStr: string;
    public EquipmentSMU: number;
    public CmuAtInstall: number;
}

export class EquipmentInspectionV {
    public InspectionId: number = 0;
    public Inspector: UserViewModel = new UserViewModel();
    public Equipment: EquipmentViewModel = new EquipmentViewModel();
    public Eval: EvalDetailsV = new EvalDetailsV();
    public CompartTypes: CompartType[] = [];
}